import * as OfferingType from 'marketplace-ui-common/offerings/constants/OfferingType';
import * as ReviewTypes from './ReviewType';
export const OfferingReviewType = {
  [OfferingType.MODULE]: ReviewTypes.MODULE,
  [OfferingType.THEME]: ReviewTypes.THEME,
  [OfferingType.APP]: ReviewTypes.APP
};